module.exports = __webpack_public_path__ + "img/valerio_18_mm.d2501cf6.jpg";